export const VIDEO_CONTENT_EXTENSION_ID = '@recative/content-extension-video';
export const ACT_POINT_CONTENT_EXTENSION_ID = '@recative/content-extension-act-point';
